// extracted by mini-css-extract-plugin
export default {"container":"sqior-chart-block_container__jID43"};